import React, {useCallback, useEffect, useState} from 'react';
import classes from "./Category.module.css";
import {Accordion, AccordionTab} from 'primereact/accordion';
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {MultiSelect} from "primereact/multiselect";
import {Chip} from "primereact/chip";
import {ScrollPanel} from 'primereact/scrollpanel';
import 'primeicons/primeicons.css';
import {sortAlphabetically} from "../../../../../api/utils/sortArrays";
import {checkCategoryTopicValidity, checkCategoryValidity} from "../../../../../api/utils/data-collection-form";
import {updateProperty} from "../../../../../api/utils/conditions-utils";
import {replaceMultiSpaceWithSingleSpace} from "../../../../../api/utils/Strings";
import MultiSelectWithAdd from "../../../DataCollections/Multiselect/MultiSelectWithAdd";
import {Checkbox} from "primereact/checkbox";
import {Dropdown} from "primereact/dropdown";

const Category = (props) => {
    const [cv, cm] = checkCategoryValidity(props.name, props.categories)
    const [sv, sm] = checkCategoryTopicValidity(props.modelTopic, props.selectedTopics)
    const [isCategoryNameValid, setIsCategoryNameValid] = useState(updateProperty(props.collapsed, cv, true));
    const [categoryNameErrorMessage, setCategoryNameErrorMessage] = useState(updateProperty(props.collapsed, cm, ""));
    const [isCategoryTopicsValid, setIsCategoryTopicsValid] = useState(updateProperty(props.collapsed, sv, true));
    const [categoryTopicsErrorMessage, setCategoryTopicsErrorMessage] = useState(updateProperty(props.collapsed, sm, ""));
    const [firstClick, setFirstClick] = useState(true);
    const [uploadMethods, setUploadMethods] = useState([]);
    const [filteredTopics, setFilteredTopics] = useState(props.modelTopic)
    useEffect(() => {
        const [v, m] = checkCategoryValidity(props.name, props.categories)
        setCategoryNameErrorMessage(m)
        setIsCategoryNameValid(v)
    }, [props.name, props.collapsed])

    useEffect(() => {
        const [v, m] = checkCategoryTopicValidity(props.modelTopic, props.selectedTopics)
        setIsCategoryTopicsValid(v)
        setCategoryTopicsErrorMessage(m)
    }, [props.selectedTopics, props.collapsed])

    const handleChange = (event) => {
        updateFirstClick();
        props.onChange(event.target.name, event.target.value, props.elementIndex);
    }

    const deleteCategory = (index) => {
        props.onDelete(index);
    }

    const handleDelete = (p) => {
        const topics = props.selectedTopics.filter(i => i.id !== p.id);
        props.onChange("topics", topics, props.elementIndex)
    };

    const updateFirstClick = useCallback(() => {
        if (firstClick) {
            setFirstClick(false);
        }
    }, [firstClick])

    const isCategoryNameErrorVisible = () => {
        return !updateProperty(props.collapsed,
            isCategoryNameValid,
            isCategoryNameValid || (firstClick && !props.isEditMode))
    }
    /**
     * Check if topic error should be visible
     * if zone is collapsed --> return validation status
     * else return validation status or first click on component and not edit mode
     * */
    const isCategoryTopicErrorVisible = () => {
        return !updateProperty(props.collapsed,
            isCategoryTopicsValid,
            isCategoryTopicsValid || (firstClick && !props.isEditMode))
    }


    const handleMandatoryDataCheck = (e) => {
        props.onChange("mandatory", e.checked, props.elementIndex);
        e.stopPropagation();
    };
    const filterTopics = (name) => {
        var topics = props.modelTopic?.filter(topic =>
            topic.uploadMethods?.some(method => method.name === name ));
        setFilteredTopics(topics);
    }
    useEffect(() => {
       var topics =props.selectedTopics?.filter(i => i.uploadMethods?.some(x => x.name === props.uploadMethod?.name))
       props.onChange("topics", topics, props.elementIndex)
    }, [props.uploadMethod]);
    useEffect(() => {
        const uploadMethodsSet = new Set();
        props.modelTopic?.forEach(topic => {
            topic.uploadMethods?.forEach(method => {
                if (![...uploadMethodsSet].some(x => x.name === method.name)) {
                    uploadMethodsSet.add(method);
                }
            });
        });
        filterTopics(props.uploadMethod?.name)
        setUploadMethods(Array.from(uploadMethodsSet));
    }, [props.modelTopic]);
    const headerTemplate = (title, isMandatory) => (
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
            <span>{title}</span>
            <div style={{display: 'flex', alignItems: 'center'}}>
                <Checkbox
                    inputId="mandatory"
                    checked={isMandatory}
                    onChange={handleMandatoryDataCheck}
                    onBlur={updateFirstClick}
                />
                <label htmlFor="mandatory" style={{marginLeft: '0.5rem'}}>
                    Mandatory Data
                </label>
            </div>
        </div>
    );

    return (<div>
        <br/>
        <div className="grid">
            <div className="col-1"/>
            <div className="col-8">
                <Accordion activeIndex={0} onBlur={updateFirstClick}>
                    <AccordionTab header={headerTemplate(props.name, props.categories[props.elementIndex].mandatory)}>
                        <div className="grid">
                            <div className="col-6">
                                <p><b>Name</b></p>
                                <InputText name="name" value={props.name}
                                           className={`${classes.inputStyle} ${updateProperty(isCategoryNameErrorVisible(), "p-invalid block", "")}`}
                                           onChange={(e) => handleChange({
                                               target: {
                                                   name: e.target.name,
                                                   value: replaceMultiSpaceWithSingleSpace(e.target.value)
                                               }
                                           })}
                                           onBlur={updateFirstClick}
                                />
                                {updateProperty(isCategoryNameErrorVisible(), <small
                                    className="p-error block">{categoryNameErrorMessage}</small>, null
                                )}
                                <p><b>Upload method </b></p>
                                <Dropdown name="uploadMethod"
                                          value={props.uploadMethod}
                                          options={uploadMethods}
                                          optionLabel="name"
                                          className={classes.dropDown}
                                          placeholder="Select upload method" filter

                                          onChange={(e) => {
                                              handleChange(e);
                                              filterTopics(e.target.value?.name)
                                          }}
                                />
                                <p><b>Topics </b></p>
                                <MultiSelect name="topics" fixedPlaceholder={true} value={props.selectedTopics}
                                             disabled={props.dataModelDisabled || props.uploadMethod === undefined}
                                             className={classes.dropDown}
                                             options={sortAlphabetically(filteredTopics, 'name')}
                                             onChange={(e) => handleChange(e)}
                                             optionLabel="name"
                                             placeholder="Select Topics" filter/>
                                {updateProperty(isCategoryTopicErrorVisible(), <small
                                    className="p-error block">{categoryTopicsErrorMessage}</small>, null
                                )}
                                <p><b>Tags </b></p>
                                <MultiSelectWithAdd name="tags" fixedPlaceholder={true}
                                                    selectedTags={props.selectedTags}
                                                    className={classes.dropDown}
                                                    options={props.tags}
                                                    onChange={(e) => handleChange(e)}
                                                    optionLabel="name"
                                                    addItem={props.addTag}
                                                    placeholder="Select tags"/>
                            </div>
                            <div className="col-6">
                                <br/><br/>
                                <ScrollPanel className={classes.mainDiv}
                                             style={{borderColor: updateProperty(isCategoryTopicErrorVisible(), 'red', 'lightgrey')}}>
                                    {props.selectedTopics.map((sh) => {

                                            return <Chip key={sh.id} label={(
                                                sh.targetYearStart !== 0 ?
                                                    <div>{sh.name}<b>({sh.targetYearStart}-{sh.targetYearEnd})</b></div> :
                                                    <div>{sh.name}</div>
                                            )}
                                                         onRemove={_ => handleDelete(sh)} className={"mb-2"}
                                                         removable/>
                                        }
                                    )}
                                </ScrollPanel>
                            </div>
                            <div className="col-11">
                                <br/>
                                <span className="pi pi-info-circle"/>
                                <small className={classes.iconInfo}>Topics names are extracted from the chosen
                                    model</small>
                            </div>
                            <div className="col-1">
                                <Button type="button" className={classes.customButton} icon=" pi pi-trash"
                                        onClick={deleteCategory}/>
                            </div>

                        </div>
                    </AccordionTab>

                </Accordion>
            </div>
        </div>

    </div>)

}

export default Category;
